
const Card = ({header, para, badge}) => {

    return (
        <>
        <div class="lively-card">
            <span class="card-badge">{badge}</span>
            <h3>{header}</h3>
            <p>{para}</p>
            <a href="#">Learn More →</a>
        </div>
        </>
    );
}

export default Card;